export default {
  backendApi: "https://keycmastaging-backend.testyourapp.online",
  // https://api.keycma.com
};
